import ACTIONS from "../../constants/actions";
import {Map} from "immutable";

const localStorageKey = 'viewed-news';
const dataFromLs = localStorage.getItem(localStorageKey);
const initialState = dataFromLs ? JSON.parse(dataFromLs) : {};

export default function viewedNews(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.VIEWED_NEWS.ADD: {
			let map = Map(state);

			if ( Array.isArray(action.data) ) {
				action.data.forEach((item) => {
					if ( !map.has(item) ) {
						map = map.set(item, true);
					}
				});
			}

			if ( typeof action.data === 'string' ) {
				const newsId = parseInt(action.data);
				if ( !map.has(newsId) ) {
					map = map.set(newsId, true);
				}
			}

			localStorage.setItem(localStorageKey, JSON.stringify(map.toObject()));
			return map.toObject();
		}

		case ACTIONS.VIEWED_NEWS.REMOVE: {
			const map = Map(state);
			const newsId = action.data;

			if ( map.has(newsId) ) {
				map.remove(newsId);
			}

			localStorage.setItem(localStorageKey, JSON.stringify(map.toObject()));
			return map.toObject();
		}

		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/viewed-news.js